define('modules/form_editor/views/editor_dropdown_item',['require','exports','module','base/itemview','ldsh!../templates/editor_dropdown_item'],function(require, exports, module){
  "use strict";
  var ItemView = require("base/itemview");
  module.exports = ItemView.extend({
    template: require("ldsh!../templates/editor_dropdown_item"),
    className: "ed-form-group ed-input-group",
    events: {
      "change .js-text": "updateModel",
      "change .js-value-text": "updateValue",
      "click .js-toggle-value": "toggleValue",
      "click .js-add": "addItem",
      "click .js-remove": "removeItem"
    },
    updateModel: function(e){
      var prevValue = this.model.get("value"),
          prevText = this.model.get("text"),
          text = this.$(".js-text").val().trim();

      e.preventDefault();
      if(text === prevText) {
        return;
      }
      this._toggleModelBinding(false);
      this.model.set("text", text);
      if(!prevValue || (prevValue === prevText)){
        //it was using the previous text as value, so update it
        //for backwards compatibility, value may be empty
        this.model.set("value", text);
        this.$(".js-value-text").val(text);
      }
      this._toggleModelBinding(true);
    },
    updateValue: function(e){
      var prevValue = this.model.get("value"),
          value = this.$(".js-value-text").val().trim();

      this._toggleModelBinding(false);
      this.model.set("value", value);
      this._toggleModelBinding(true);
    },
    helpers: function(){
      return {
        value: this.model.get("valid") ?
          this.model.get("value") || this.model.get("text") :
          ""
      };
    },
    addItem: function(e){
      e.preventDefault();
      this.trigger("item:add");
    },
    removeItem: function(e){
      e.preventDefault();
      this.trigger("item:remove");
    },
    toggleValue: function(e){
      this.$(".js-item-value").toggleClass("hidden");
    },
    onRender: function(){
      if(!this.model.get("valid")){
        this.$(".js-toggle-value")
          .addClass("is-disabled")
          .attr("disabled", true);
      }
      this.$el.i18n();
    },
    _toggleModelBinding: function(isListening){
      if(isListening){
        this.listenTo(this.model, "change", this.render);
      }
      else {
        this.stopListening(this.model);
      }
    }
  });
});

